import { authenticatedFetch } from "./apiClient";
import { parseJsonOrThrow } from "../utils/apiRequestError";

export type AutomatedTradingStatus = {
  automated_trading_enabled: boolean;
  automated_trading_enabled_until?: string | null;
  time_remaining_seconds?: number | null;
};

export type AutomatedTradingArm = {
  arm_id?: string | null;
  strategy_id?: string | null;
  account_code?: string | null;
  enabled: boolean;
};

export type AutomatedTradingArmsStatus = {
  items: AutomatedTradingArm[];
};

export async function fetchAutomatedTradingStatus(): Promise<AutomatedTradingStatus> {
  const res = await authenticatedFetch("/v1/automated-trading/status");
  return parseJsonOrThrow(res, "Failed to load automated trading status");
}

export async function enableAutomatedTrading(payload?: { expiry_hours?: number }): Promise<AutomatedTradingStatus> {
  const res = await authenticatedFetch("/v1/automated-trading/enable", {
    method: "POST",
    body: payload ? JSON.stringify(payload) : undefined,
  });
  return parseJsonOrThrow(res, "Failed to enable automated trading");
}

export async function disableAutomatedTrading(): Promise<AutomatedTradingStatus> {
  const res = await authenticatedFetch("/v1/automated-trading/disable", { method: "POST" });
  return parseJsonOrThrow(res, "Failed to disable automated trading");
}

export async function fetchAutomatedTradingArmsStatus(): Promise<AutomatedTradingArmsStatus> {
  const res = await authenticatedFetch("/v1/automated-trading/arms/status");
  return parseJsonOrThrow(res, "Failed to load automated trading arms status");
}

export async function enableAutomatedTradingArm(payload: {
  arm_id?: string;
  account_code?: string;
}): Promise<AutomatedTradingArmsStatus> {
  const res = await authenticatedFetch("/v1/automated-trading/arms/enable", {
    method: "POST",
    body: JSON.stringify(payload ?? {}),
  });
  return parseJsonOrThrow(res, "Failed to enable automated trading arm");
}

export async function disableAutomatedTradingArm(payload: {
  arm_id?: string;
  account_code?: string;
}): Promise<AutomatedTradingArmsStatus> {
  const res = await authenticatedFetch("/v1/automated-trading/arms/disable", {
    method: "POST",
    body: JSON.stringify(payload ?? {}),
  });
  return parseJsonOrThrow(res, "Failed to disable automated trading arm");
}
